import { GridItem } from "@tvg/fuse/grid";
import { useMainState } from "client/state/Main";
import { useODMEffect, useODMSubEffect } from "client/state/useODM";
import React, { useState } from "react";
import AccountIcon from "../AccountIcon";
import BasketIcon from "../BasketIcon";
import styles from "../ComplexHeader.module.css";
import MyOffersIcon from "../MyOffersIcon";
import SavedIcon from "../SavedIcon";
import SearchIcon from "../search/SearchIcon";

interface OdmDataType {
  s4l: boolean;
  basketCount: string;
  myOffersCount: string;
}

interface IconWrapperProps {
  onSearchClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ onSearchClick }) => {
  const { isCreditCustomer, brand, isMyOffersEnabled } = useMainState(
    (state) => ({
      isCreditCustomer: state.isCreditCustomer,
      brand: state.brand,
      isMyOffersEnabled: state.isMyOffersEnabled,
    }),
  );

  const [odmData, setOdmData] = useState<OdmDataType>({
    s4l: false,
    basketCount: "0",
    myOffersCount: "0",
  });

  const isMyOffersEligibleBrandAlways =
    brand === "very" || brand === "littlewoods";
  const isMyOffersEligibleBrandWhenEnabled =
    brand === "veryireland" && !!isMyOffersEnabled;
  const isMyOffersEligibleBrand =
    isMyOffersEligibleBrandAlways || isMyOffersEligibleBrandWhenEnabled;
  const shouldShowMyOffersIcon = isMyOffersEligibleBrand && isCreditCustomer;
  const shouldFetchMyOffersCount =
    shouldShowMyOffersIcon && !!isMyOffersEnabled;

  const myOffersHref = isMyOffersEnabled ? "/my-offers" : "/myoffers.page";

  useODMEffect(setOdmData, { shouldFetchMyOffersCount });
  useODMSubEffect(setOdmData, odmData);

  const { s4l, basketCount, myOffersCount } = odmData;

  return (
    <GridItem
      className={`${styles.complexHeader__iconGroupWrapper} complex-header__icon-group-wrapper`}
    >
      <div
        className={`${styles.complexHeader__iconsContainer} complex-header__icons-container`}
        data-testid="complex-header-icon-group-container"
      >
        <SearchIcon /* Only visible in mobile viewport */
          data-testid="mobile-header-search"
          onSearchClick={onSearchClick}
        />
        {shouldShowMyOffersIcon && (
          <div
            className={`${styles.complexHeader__myOffersIcon} complex-header__my-offers-icon`}
          >
            <MyOffersIcon
              data-testid="complex-header-my-offers-container"
              href={myOffersHref}
              notification={
                shouldFetchMyOffersCount && myOffersCount !== "0"
                  ? myOffersCount
                  : ""
              }
            />
          </div>
        )}
        <AccountIcon data-testid="complex-header-account-container" />
        <SavedIcon
          brand={brand}
          data-testid="complex-header-saved-container"
          notification={s4l ? `${s4l}` : ""}
        />
        <BasketIcon
          notification={basketCount === "0" ? "" : basketCount}
          data-testid="complex-header-basket-container"
        />
      </div>
    </GridItem>
  );
};

export default IconWrapper;
